import { debounce, each } from 'underscore'
import $ from 'jquery'

const NodeFilter = typeof window !== 'undefined' ? window.NodeFilter : {}

// special cases: menus, popups etc.
const specials = [
  {
    targetClass: 'profile--dropdown-trigger',
    elements: '.main-navigation--profile-link .dropdown'
  }
]

// elements whose click event should be hijacked
const hijacks = [
  '.js-cancel-crop',
  '.js-save-crop',
  '.js-menu-dropdown-toggle'
]

class DocumentParser {
  init (onPhraseGetStart, onPhraseGetEnd, onTranslateEnd) {
    const self = this
    this.associated = {}
    this.onPhraseGetStart = onPhraseGetStart
    this.onPhraseGetEnd = onPhraseGetEnd
    this.onTranslateEnd = onTranslateEnd

    // deal with multiple ajax calls
    const debounceParse = debounce(() => {
      self.prepareDoc()
    }, 1000).bind(this)

    // re-parse after ajax operations
    $(document).ajaxComplete((event, xhr, options) => {
      if (!/\/phrase\//.test(options.url)) {
        debounceParse()
      }
    })

    // if no ajax calls occur:
    debounceParse()
  }

  exit () {
    document.removeEventListener('click', this.handleClick)
    document.body.classList.remove('page-loading')
  }

  enableDropdownLinks () {
    // phrase-enable popups
    const pops = document.querySelectorAll('.dropdown, .dropdown-links__item-link')
    each(pops, pop => {
      pop.removeEventListener('click', this.handleClick.bind(this))
      pop.addEventListener('click', this.handleClick.bind(this))
    })
  }

  enableAvatarModal () {
    // show avatar upload modal
    const avatarUploader = document.querySelector('.js-avatar-uploader .is-hidden')
    if (avatarUploader) {
      avatarUploader.classList.remove('is-hidden')
      avatarUploader.classList.add('mfp-content')
    }
  }

  prepareDoc () {
    this.parse()
    this.enableDropdownLinks()
    this.enableAvatarModal()
    setTimeout(() => {
      document.body.classList.remove('page-loading')
    }, 500)
  }

  // get (latest) phrase data.
  getTranslation (key) {
    const data = key.split('--')
    this.onPhraseGetStart()

    $.get('/phrase/item', {
      category: data[0],
      message: data[1],
      params: data[2],
      key: key
    }, data => {
      this.onPhraseGetEnd(data)
    })
  }

  // click on document: if phrase then retrieve associated phrase data
  handleClick (e) {
    let target = e.target
    const self = this
    // special case: button
    if (target.tagName === 'BUTTON') {
      target = target.querySelector('.js-phrase')
    }
    if (!target) return
    // selectize click
    if (target.classList.contains('selectize-input')) {
      this.parse(target.parentNode)
    }
    // selectize option click
    if (target.parentNode.classList.contains('option')) {
      setTimeout(() => {
        self.parse(target.parentNode.parentNode.parentNode.parentNode)
      }, 300)
    }
    // other special cases (popup menus and the like)
    let elements = this.associated.elements
    if (elements) {
      elements = document.querySelector(elements)
      if (elements && !elements.contains(target)) {
        elements.classList.add('is-hidden')
        this.associated = {}
      }
    }
    // halt events
    if (target.classList.contains('js-phrase') || target.parentNode.classList.contains('js-phrase')) {
      e.preventDefault()
      e.stopImmediatePropagation()
    }
    // regular behaviour: translate phrase
    if (target.classList.contains('js-phrase')) {
      const attributeData = target.parentNode.hasAttribute('data-translationkey')
        ? target.parentNode.getAttribute('data-translationkey')
        : target.parentNode.querySelector('.js-phrase_placeholder').getAttribute('data-translationkey')
      this.getTranslation(attributeData)
    }

    // take care of special cases
    specials.forEach(special => {
      if (target.parentNode.classList.contains(special.targetClass)) {
        e.preventDefault()
        e.stopImmediatePropagation()
        this.associated = special
        document.querySelector(this.associated.elements).classList.remove('is-hidden')
        if (special.phrase) {
          this.getTranslation(document.querySelector(special.phrase).getAttribute('data-translationkey'))
        }
      }
    })
  }

  // submit new/ updated phrase
  translate (query) {
    const affected = document.querySelectorAll('*[data-translationkey^="' + query.category + '--' + query.message + '"]')
    $.get('/phrase/edit', query, (data) => {
      // update all affected phrases in dom
      each(affected, item => {
        let param = item.getAttribute('data-translationparam')
        let translation = data.translation
        /* translate on the fly: */
        // 1) translate variable's value
        if (param && param.length) {
          param = param.split(',')
          translation = translation.replace(param[0], param[1])
        // 2) translate singular/ plural
        } else {
          const dual = translation.split('|')
          if (dual.length > 1) {
            const number = parseInt(item.innerHTML.replace(/\D/g, ''), 10)
            if (number === 1) {
              translation = dual[0].replace(/\{.+\}/, 1)
            } else {
              translation = dual[1].replace(/\{.+\}/, number)
            }
          }
        }
        if (item.hasAttribute('placeholder')) {
          const icon = item.classList.contains('bigsearch-input') ? item.getAttribute('placeholder').charAt(0) + ' ' : ''
          item.setAttribute('placeholder', icon + translation)
        } else if (item.hasAttribute('data-placeholder')) {
          item.setAttribute('data-placeholder', translation)
        } else {
          item.innerHTML = translation + '<span class="js-phrase js-phrase_edit-btn">edit</span>'
        }
      })
      this.onTranslateEnd(data)
    })
  }

  toggleHijacks (on) {
    each(hijacks, item => {
      const el = document.querySelector(item)
      if (el) {
        if (on) {
          el.addEventListener('click', this.handleClick.bind(this))
        } else {
          el.removeEventListener('click', this.handleClick.bind(this))
        }
      }
    })
  }

  toggleListeners (on) {
    if (on) {
      document.addEventListener('click', this.handleClick.bind(this), { capture: true })
      each(document.querySelectorAll('.selectize-dropdown .js-phrase'), item => item.addEventListener('mousedown', this.handleClick.bind(this)))
    } else {
      document.removeEventListener('click', this.handleClick.bind(this))
      each(document.querySelectorAll('.selectize-dropdown .js-phrase'), item => item.removeEventListener('mousedown', this.handleClick.bind(this)))
    }
    this.toggleHijacks(on)
  }

  // parse whole document
  parse (container = document) {
    let walker
    const nodes = []
    let item

    this.toggleListeners(false)

    // disable (most) attribute editing for now (re-inserting regular phrase value)
    // just placeholder editing allowed
    walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, null, false)
    while (walker.nextNode()) {
      Array.from(walker.currentNode.attributes).forEach(att => {
        const val = att.nodeValue
        if (att.nodeName === 'placeholder' || att.nodeName === 'data-placeholder') {
          try {
            const editBtn = document.createElement('span')
            editBtn.className = 'js-phrase js-phrase_edit-btn'
            editBtn.innerHTML = 'edit'
            const vals = /(\s*)(.*)::phrase::(.*)::phrase::(.*)(\s*)/.exec(val.replace(/\n/g, ' '))
            walker.currentNode.setAttribute('data-translationkey', this.getData(vals[3]))
            walker.currentNode.classList.add('js-phrase_placeholder')
            walker.currentNode.parentNode.classList.add('js-phrase-container')
            walker.currentNode.parentNode.appendChild(editBtn)
          } catch (err) {
            // console.log('failed to set attribute on', walker.currentNode)
          }
        }
        att.nodeValue = val.replace(/\n/g, ' ').replace(/::phrase::.*::phrase::/, this.getData(val, 2))
      })
    }

    // get all phrase text nodes
    walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, item => {
      if (
        item.nodeValue.replace(/\n/g, ' ').match(/::phrase::.*::phrase::/) && item.parentNode.tagName !== 'SCRIPT'
      ) {
        return NodeFilter.FILTER_ACCEPT
      }
    }, false)
    while ((item = walker.nextNode())) {
      nodes.push(item)
    }
    // transform phrase text nodes
    nodes.forEach(item => {
      const val = /(\s*)(.*)::phrase::(.*)::phrase::(.*)(\s*)/.exec(item.nodeValue.replace(/\n/g, ' '))
      const txt = val[2] +
        '<span data-translationkey="' +
        this.getData(val[3]) +
        '" data-translationparam="' +
        this.getData(val[3], 3) + '">' +
        this.getData(val[3], 2) + '' +
        '<span class="js-phrase js-phrase_edit-btn">edit</span>' +
        '</span>' +
        val[4]
      if (item.parentNode) item.parentNode.innerHTML = txt
    })
    this.toggleListeners(true)
  }

  // get appropriate phrase data
  getData (phrase, index) {
    let ret = phrase.replace(/\n/g, ' ').replace(/::phrase::/g, '')
    if (index) {
      ret = ret.split('--')
      if (ret[index]) {
        return ret[index]
      }
      return ''
    }
    return ret.trim()
  }
}

export default new DocumentParser()
